import * as Storage from "../lib/Storage.ts";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";
import { toLocaleString } from "../lib/DateUtils.ts";
import { Calendar } from "../lib/fullcalendar/all.ts";

var currentFullCalendar:Calendar;

Html.registerDom({
  timetabletoday:function() {
    currentFullCalendar.today();
  },
  timetablenext:function() {
    currentFullCalendar.next();
  },
  timetableprev:function() {
    currentFullCalendar.prev();
  },
  timetableview:function(value){
    Storage.localSet('settings.timetableView',value);
    currentFullCalendar.changeView(value)
  }
});
/**
 * @param currenttimetable the TimetableBean
 * @param info the info from fullCalendar
 */
export function updateViewSelector(currenttimetable, info){
  ['timeGridDay','timeGridWeek','dayGridMonth','listYear'].forEach(viewType=>{
    const el = document.querySelector(`[data-fw-onclick="timetableview|${viewType}"]`);
    if(el){
      el.classList.toggle('selected',viewType===info.view.type);
    }
  })
  if(currenttimetable.isOneTime){
    const prevBtn = document.querySelector('[data-fw-onclick="timetableprev"]') as HTMLElement;
    const nextBtn = document.querySelector('[data-fw-onclick="timetablenext"]') as HTMLElement;
    if(prevBtn) prevBtn.style.display = '';
    if(nextBtn) nextBtn.style.display = '';

    const timenavMain = document.querySelector('.timenav-main') as HTMLElement;
    const timenav = document.querySelector('.timenav') as HTMLElement;
    if(timenavMain) timenavMain.textContent = info.view.title;
    if(timenav) timenav.style.display = '';

    return;
  }
  var weeks = currenttimetable.weeks;
  if(info.view.type==="timeGridWeek"){
    const timenav = document.querySelector('.timenav') as HTMLElement;
    if(currenttimetable.recurrencyDescriptor.recurrencyInterval===1){
      if(timenav) timenav.style.display = 'none';
      return;
    }else{
      if(timenav) timenav.style.display = '';
      let weekIdx: number;
      for(weekIdx=weeks.length-1;weekIdx>=0;weekIdx--){
        let week = weeks[weekIdx];
        if(info.view.currentStart.getTime()>=week.start.getTime()){
          currenttimetable.currentWeekIndex = weekIdx;
          const timenavMain = document.querySelector('.timenav-main') as HTMLElement;
          if(timenavMain){
            timenavMain.textContent = week.name+(week.isCurrent?' - '+i18n.get('timetable.current'):'');
          }
          break;
        }
      }
      const prevBtn = document.querySelector('[data-fw-onclick="timetableprev"]') as HTMLElement;
      const nextBtn = document.querySelector('[data-fw-onclick="timetablenext"]') as HTMLElement;
      if(prevBtn) prevBtn.style.display = weekIdx > 0 ? '' : 'none';
      if(nextBtn) nextBtn.style.display = weekIdx < weeks.length-1 ? '' : 'none';
    }
  }else if(info.view.type==="timeGridDay"){
    const timenav = document.querySelector('.timenav') as HTMLElement;
    if(timenav) timenav.style.display = '';
    let weekIdx: number;
    for(weekIdx=weeks.length-1;weekIdx>=0;weekIdx--){
      let week = weeks[weekIdx];
      if(info.view.currentStart.getTime()>=week.start.getTime()){
        currenttimetable.currentWeekIndex = weekIdx;
        var displayWeek = weeks.length>1?week.name+' - ':'';
        const timenavMain = document.querySelector('.timenav-main') as HTMLElement;
        if(timenavMain){
          timenavMain.textContent = displayWeek+toLocaleString(info.view.currentStart,{weekday:'long'});
        }
        break;
      }
    }
    const prevBtn = document.querySelector('[data-fw-onclick="timetableprev"]') as HTMLElement;
    const nextBtn = document.querySelector('[data-fw-onclick="timetablenext"]') as HTMLElement;
    if(prevBtn) prevBtn.style.display = info.view.currentStart.getTime()>weeks[0].start.getTime() ? '' : 'none';
    if(nextBtn) nextBtn.style.display = info.view.currentEnd.getTime()<weeks[weeks.length-1].end.getTime() ? '' : 'none';
  }
      
}



export function set(calendar :Calendar,timetable){
  currentFullCalendar = calendar;
}
function getAllowedView(timetable){
  var allowedView;
  if(timetable.isOneTime){
    allowedView = ['timeGridDay','timeGridWeek'/*,'dayGridMonth','listYear'*/]
  }else{
    allowedView = ['timeGridDay','timeGridWeek']
  }
  ['timeGridDay','timeGridWeek','dayGridMonth','listYear'].forEach(viewType=>{
    const el = document.querySelector(`[data-fw-onclick="timetableview|${viewType}"]`) as HTMLElement;
    if(el){
      el.style.display = allowedView.indexOf(viewType)>-1 ? '' : 'none';
    }
  })
  return allowedView;
}
export function getView(timetable){
  const 
    storedView = Storage.localGet('settings.timetableView');
  if(getAllowedView(timetable).indexOf(storedView)===-1){
    return 'timeGridWeek'
  }  
  return storedView;
}
export function get():Calendar{
  return currentFullCalendar;
}